import { render, staticRenderFns } from "./BackupDocument.vue?vue&type=template&id=6c6e1325&scoped=true"
import script from "./BackupDocument.vue?vue&type=script&lang=js"
export * from "./BackupDocument.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/panel-simple.css?vue&type=style&index=0&id=6c6e1325&prod&scoped=true&lang=css&external"
import style1 from "./BackupDocument.vue?vue&type=style&index=1&id=6c6e1325&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6e1325",
  null
  
)

export default component.exports